import React from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Box from "@material-ui/core/Box";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    marginTop: 8,
    marginBottom: 16,
    backgroundColor: "#F2F2F2",
    border: "1px solid #CACCD1"
  }
});

export default function ListItem({
  title,
  desc,
  openDeleteDialog,
  openEditDialog
}) {
  const { root } = useStyles();
  return (
    <Grid container className={root}>
      <Grid container justify="space-between" alignItems="center">
        <Typography component="div">
          <Box fontSize={14} py={1} pl={2} color="#00334E">
            {title}
          </Box>
        </Typography>
        <Box pr={1}>
          <Tooltip title="Редактировать" placement="top-start">
            <IconButton size="small" onClick={() => openEditDialog()}>
              <EditOutlinedIcon fontSize="small" style={{ fill: "#93A7BE" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Удалить" placement="top-start">
            <IconButton size="small" onClick={openDeleteDialog}>
              <DeleteForeverOutlinedIcon
                fontSize="small"
                style={{ fill: "#93A7BE" }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      </Grid>
      {desc && (
        <Typography component="div">
          <Box fontSize={12} pb={1} pl={2} color="#778899">
            {desc}
          </Box>
        </Typography>
      )}
    </Grid>
  );
}
